// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tARy","input":"styles_input__3G6qy"};